export default __webpack_public_path__ + "static/assets/93edc93cc2257f1b5110d56d6ffb1f6f.svg";